export default __webpack_public_path__ + "static/media/16_tag_kitchen.63bab5da.svg";